<template>
	<div class="template-wrapper">
		<h2 class="page-title">{{ $t('topupPlan') }}</h2>
		<el-divider></el-divider>
		<template v-if="store_management === '1'">
            <el-row :gutter="30">
                <el-col :xs="12" :sm="12" :md="6" :lg="6" v-for="item in tableData" :key="item.storeid">
                    <template v-if="item.plan_type === 'monthly'">
                        <el-card shadow="always">
                            <div class="grid-content">
                                <h5>{{ item.name }}</h5>
                                <br />
                                <ul class="custom-list">
                                    <li class="list-item" v-for="(line, index) in splitByNewline(item.des)" :key="index">
                                        {{ line }}
                                    </li>
                                </ul>
                                <br />
                                <p class="textleft">{{ $t("officialPrice") }}: <del>HK${{ item.official_price }}</del></p>
                                <p class="textleft">{{ $t("newPrice") }}: HK${{ item.price }}</p>
                                <br />
                                <p class="textleft">{{ $t("subscriptionPeriod") }}:</p>
                                <el-select v-model="item.default_months">
                                    <el-option :label="`6${$t('months')}`" value="6"></el-option>
                                    <el-option :label="`12${$t('months')}`" value="12"></el-option>
                                    <el-option :label="`24${$t('months')}`" value="24"></el-option>
                                </el-select>
                                <br /><br />
                                <el-button round @click="showFPSQRCode(item.id, item.price, item.default_months)">{{ $t("select") }}</el-button>
                            </div>
                        </el-card>
                    </template>
                    
                </el-col>
            </el-row>
            
            <el-dialog :title="$t('fpspay')" :visible.sync="dialogVisible" :width="$store.state.isMobile ? '90%' : '556px'"
			:before-close="handleClose">
			    <div class="add-template centered-content">
                    <template v-if="startPay === true">
                        <h4>{{ $t("payOrderid") }}: {{ fpsorderid }}</h4>
                        <img style="max-width: 300px;" v-if="fpsQR" :src="fpsQR" />
                    </template>
                    <template v-else-if="isPolling === false && fpspaymentid">
                        <img style="max-width: 200px;" src="/success.jpeg" />
                        <h2>{{ $t("paySuccess") }}</h2>
                        <h4>{{ $t("payOrderid") }}: {{ fpsorderid }}</h4>
                        <h4>{{ $t("payPaymentid") }}: {{ fpspaymentid }}</h4>
                    </template>
                </div>
            </el-dialog>
		</template>
		<template v-if="store_management === '0'">
            <span>{{ $t("NoPermissions") }}</span>
        </template>



        




        

	</div>
</template>
<script>
import {
	formatDate
} from '../../assets/date.js'
import axios from 'axios'
import {
	tongyong,
	funk,
	getStore,
	addStore,
    getStoreauthorizelist,
    addStoreauthorizelist,
    editStoreauthorizelist,
    deleteStoreauthorizelist,
    getinfoStoreauthorizelist,
    addStoreposlist,
    getStoreposlist,
    storeposiplist,
    getPickupaddresslist,
    getStoreTopupusage,
    getStoreTopuplist,
    checktopuppayment
} from '@/api'
import {
	addAutoTemplate
} from '@/api'
export default {
	data() {
		return {
			store_management: '0',
			exportcsv: '0',
			qyid: '',
            storeid:'',
            fpsorderid: '',
            fpspaymentid: '',
            fpsQR: '',
            isPolling: false,
            intervalId: null,
            startPay: false,
			dialogImageUrl: '',
			fileList: [],
			disabled: false,
			showViewer: false, // 显示查看器
			ewmdata: [],
			fileList: [],
			pagelist: [],
			huodonglist: [],
			currentPage: 1, // 当前页码
			pageSize: 20, // 每页显示的行数
			activeName: '0',
			dialogVisible: false,
			tab: [{
				label: this.$t('underApproval'),
				id: '0'
			},
			{
				label: this.$t('passed'),
				id: '1'
			}
			],
			tableData: [],
			tableData1: [

				{
					timer: '2018-01-01',
					name: '测试範本001',
					status: '审核中'
				},
			],
			metaTemplateList: [],
			status: 0,
			form: {
				qyid: '',
				storeid: '',
				name: '',
				businesswhatsapp: '',
				adminwhatsapp: '',
				adminemail: '',
                isshipping: false,
                shippingflowid: ''

			},
			editform: {
				qyid: '',
				storeid: '',
				name: '',
				businesswhatsapp: '',
				adminwhatsapp: '',
				adminemail: '',
                isshipping: false,
                shippingflowid: ''

			},
            storeauthorizeform: {
                name:'',
                loginname:'',
                password:''
            },
            storeposform: {
                name:'',
                isDefault: '0'
            },
            storeposipform: {
                ip:''
            },
            pickupAddressform: {
                location:'',
                time: ''
            },
            editstoreauthorizeformid: '',
            editstoreposformid: '',
            storeauthorizeList: [],
            storeposList: [],
            pickupaddressList: [],
        }
	},
	filters: {
		formatDate: function (time) {
			time = time * 1000 //注意：time应为格式为13位unix時間戳，如果是10位的unix時間戳，需要乘以1000
			let date = new Date(time)
			return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
		}
	},
    mounted() {
        this.storeid = this.$route.params.topupstoreid;
    },
    beforeUnmount() {
        this.stopPolling()
    },
	created() {
		var auser = JSON.parse(window.localStorage.getItem('auserinfo'))
        this.qyid = auser.qyid
        this.storeid = auser.storeid
        this.store_management = auser.store_management
        this.exportcsv = auser.exportcsv
		this.gettemplist()
	},
	methods: {
		showFPSQRCode(planid, price, months) {
			this.dialogVisible = true
            this.startPay = true
            this.fpsorderid = ''
            this.fpspaymentid = ''
            console.log(planid, this.qyid, this.storeid)
            let fdata = {
				qyid: this.qyid,
                storeid: this.storeid,
                topupplan: planid,
                month: months,
                action: "createtopupplanpayment"
			};
            
			getStoreTopuplist(fdata).then((res) => {
				if (res.code == 1) {
                    console.log("A");
					console.log(res);
					//this.tableData = res.data;
                    this.fpsorderid = res.orderid;
                    this.fpsQR = res.qrcode;
                    this.startPolling();
				} else {
                    console.log("B");
					this.$message({
						type: "error",
						message: res.msg,
					});
				}
			});
            
		},
        async fetchPaymentStatus() {
            try {
                // Simulate API call - replace with your actual API endpoint
                let fdata = {
                    qyid: this.qyid,
                    storeid: this.storeid,
                    orderid: this.fpsorderid,
                    action: "checktopuppayment"
                };
                
                checktopuppayment(fdata).then((res) => {
                    if (res.code == 1) {
                        console.log("A");
                        //console.log(res);
                        //this.tableData = res.data;
                        //this.fpsorderid = res.orderid;
                        //this.fpsQR = res.qrcode;
                        if (res.status === 'paid') {
                            this.fpspaymentid = res.topup['paymentid']
                            this.stopPolling()
                            console.log('Payment successful! Stopping API calls.')
                        }
                    }
                    else {
                        console.log("C");
                    }
                });
                
                // Check if payment is successful
                
                
            } catch (error) {
                this.error = error.message
                console.error('API Error:', error)
            } finally {
                this.loading = false
            }
        },
        startPolling() {
            this.isPolling = true
            this.fetchPaymentStatus() // Fetch immediately
            
            this.intervalId = setInterval(() => {
                this.fetchPaymentStatus()
            }, 5000) // 5 seconds
        },
        stopPolling() {
            this.isPolling = false
            this.startPay = false
            if (this.intervalId) {
                clearInterval(this.intervalId)
                this.intervalId = null
            }
        },
		handleClose() {
			this.dialogVisible = false
            this.startPay = false
            this.stopPolling()
		},

		// 新增範本点击确定
		sure() {
			var user = JSON.parse(window.localStorage.getItem('userinfo'))
			console.log(user);

			this.form.qyid = user.id
			this.form.action = "add"

			console.log(this.form);

			addStore(this.form).then(res => {
				if (res.code == 1) {
					this.$message({
						type: 'success',
						message: res.msg
					})
					this.dialogVisible = false
					this.gettemplist()
				} else {
					this.$message({
						type: 'error',
						message: res.msg
					})
				}
			})
		},
		edit() {
			var user = JSON.parse(window.localStorage.getItem("userinfo"));
			console.log(user)

			this.editform.qyid = user.id
			this.editform.action = "edit"


			addStore(this.editform).then((res) => {
				if (res.code == 1) {
					this.$message({
						type: "success",
						message: res.msg,
					});
					this.dialogEditFormVisible = false;
					this.gettemplist()
				} else {
					this.$message({
						type: "error",
						message: res.msg,
					});
				}
			});
		},
        addStorepos() {
            this.dialogAddStoreposVisible = true
            this.storeposform.name = ""
            this.storeposform.isDefault = "0"
        },
        changedata1(id){
            console.log(id)
        },
		// 我的範本列表
		gettemplist() {
			console.log('go taocan');
			var user = JSON.parse(window.localStorage.getItem('userinfo'))

			/*
			let fdata = {
				sjk: 'messenger_storelist',
				action: 'list',
				qyid: user.id
			}
			tongyong(fdata).then(res => {
				if (res.code == 1) {
					console.log(fdata);
					console.log(res);
					this.tableData = res.data
				} else {
					this.$message({
						type: 'error',
						message: res.msg
					})
				}
			})*/
			let fdata = {
				qyid: this.qyid,
                storeid: this.storeid,
                action: "viewalltopupplan"
			};
			getStoreTopuplist(fdata).then((res) => {
				if (res.code == 1) {
                    console.log("A");
					console.log(res);
					this.tableData = res.data;
				} else {
                    console.log("B");
					this.$message({
						type: "error",
						message: res.msg,
					});
				}
			});
		},


		//pagelist 
		getpagelist() {
			console.log('go taocan');
			var user = JSON.parse(window.localStorage.getItem('userinfo'))

			let fdata = {
				sjk: 'messenger_pagelist',
				action: 'list',

				qyid: user.id
			}
			tongyong(fdata).then(res => {
				if (res.code == 1) {
					console.log(res);
					this.pagelist = res.data
				} else {
					this.$message({
						type: 'error',
						message: res.msg
					})
				}
			})
		},

		//pagelist 
		gethuodonglist() {
			console.log('go taocan');
			var user = JSON.parse(window.localStorage.getItem('userinfo'))

			let fdata = {
				sjk: 'messenger_huodong_yhq',
				action: 'list',

				qyid: user.id
			}
			tongyong(fdata).then(res => {
				if (res.code == 1) {
					console.log(res);
					this.huodonglist = res.data
				} else {
					this.$message({
						type: 'error',
						message: res.msg
					})
				}
			})
		},

        difference(item1, item2) {
            return item2 - item1
        },
        splitByNewline(text) {
            console.log('Split result:', text.split(',').filter(line => line.trim() !== ''))
            return text.split(',').filter(line => line.trim() !== '')
        },
		ewm(str, pageid) {
			var user = JSON.parse(window.localStorage.getItem('userinfo'))
			console.log(user);
			this.dialogVisible_ewm = true
			this.qyid = user.id
			let fdata = {
				do: 'ewm',
				qyid: this.qyid,
				pageid: pageid,
				ref: str,
				type: 'link',


			}
			console.log('go ewm', fdata);


			funk(fdata).then(res => {
				if (res.code == 1) {
					console.log(res);
					this.ewmdata = res
					console.log(this.ewmdata)
					// const html ='<div style="text-algin:center;">H5:<a target="_blank"  href="'+res.url+'">link</a> <br><img src='+res.path+' /> <br>Whatsapp:<a target="_blank"  href="'+res.wurl+'">link</a> <button class="tag-read" :data-clipboard-text="aaa" @click="copy">复制</button></el-button><br> <img src='+res.whatsapp+' /> <br></div>' 
					// this.$alert(html, '預約排隊二維碼', {
					//           dangerouslyUseHTMLString: true
					//         });


				} else {
					this.$message({
						type: 'error',
						message: res.msg
					})
				}
			})
		},
		//上传--

		// 删除
		handleRemove(file) {
			let uploadFiles = this.$refs.elUpload.uploadFiles;
			uploadFiles.forEach((value, index) => {
				if (value.uid === file.uid) {
					uploadFiles.splice(index, 1)
					this.fileList.splice(index, 1)
				}
			})
		},
		// 大图预览
		handlePictureCardPreview(file) {
			this.dialogImageUrl = file.url;
			this.showViewer = true;
		},
		// 下载圖片
		handleDownload(file) {
			let a = document.createElement('a');
			a.download = file.name;
			a.href = (file.url);
			a.click();
		},
		// 重写上传
		uploadSectionFile(params) {
			const file = params.file,
				fileType = file.type,
				isImage = fileType.indexOf('image') !== -1,
				isLt2M = file.size / 1024 / 1024 < 2;
			// 这里常规检验，看项目需求而定
			if (!isImage) {
				this.$message.error('只能上传圖片格式png、jpg、gif!');
				return;
			}
			if (!isLt2M) {
				this.$message.error('只能上传圖片大小小于2M');
				return;
			}
			// 根据后台需求数据格式
			const form1 = new FormData();
			// 文件对象
			form1.append('file', file);
			// 本例子主要要在请求时新增特定属性，所以要用自己方法覆盖默认的action
			// form.append("clientType", 'xxx');
			// 项目封装的请求方法，下面做简单介绍


			imageUpload(form1).then(res => {
				//自行处理各种情况
				console.log('res', res)
				this.form.image = res
			}).catch(() => {
				// xxx
			});
		},
		// 关闭
		closeViewer() {
			this.showViewer = false;
		},
		sortChange({ prop, order }) {
			this.tableData.sort(this.compare(prop, order));
		},
		compare(propertyName, sort) {
			return function (obj1, obj2) {
				var value1 = obj1[propertyName]
				var value2 = obj2[propertyName]
				if (typeof value1 === 'string' && typeof value2 === 'string') {
					const res = value1.localeCompare(value2, 'zh')
					return sort === 'ascending' ? res : -res
				} else {
					if (value1 <= value2) {
						return sort === 'ascending' ? -1 : 1
					} else if (value1 > value2) {
						return sort === 'ascending' ? 1 : -1
					}
				}
			}
		}




	}
}
</script>
<style lang="scss" scoped>
.custom-list {
  list-style-type: disc;
  list-style-position: outside;
  padding-left: 20px;
  text-align: left;
}

.list-item {

}

.textleft {
  text-align: left;
}

.grid-content {
  text-align: center;
}

.equal-height-container {
  display: flex;
}

.centered-content {
  text-align: center; /* Center text content */
}

.el-pagination__total {
	display: inline-block;
	font-size: 13px;
	min-width: 35.5px;
	height: 28px;
	line-height: 28px;
	vertical-align: top;
	box-sizing: border-box;
}

.pagination {
	width: 100%;
	margin: 30px auto;
}

::v-deep .el-select {
	width: 100%;

}

.label {
    font-size: 24px;
    font-weight: bold;
    color: rgba(0, 0, 0, .45);
    text-align: center;
}

@media screen and (max-width: 768px) {
    .label {
        font-size: 12px;
        text-align: center;
    }
}
</style>
